import ProductQuickAddModal from './product-quick-add-modal-controller'

export default ProductQuickAddModal
